import { useApiClient } from '@/api/ApiClient';
const { get2, post, post2, del, get, get3 } = useApiClient();

//FIXME: 상품조회
export const getProducts = async (params) => {
  let path = `/payments/products`;
  const { data } = await get2(path, params);
  return data;
};

/**
 * 상품 단건 조회 (GET /payments/products/{productId})
 * - 결제 금액을 상품의 실제 가격(price)으로 맞추기 위해 사용 (하드코딩 금액 불일치 방지)
 */
export const getProduct = async (productId) => {
  let path = `/payments/products/${productId}`;
  const { data } = await get2(path, {});
  return data;
};

// 상품 단건 조회 — 분석권 업셀의 추천 상품(recommendedProductId) → articleId 연결용
export const getProductById = async (productId) => {
  const path = `/payments/products/${productId}`;
  const { data } = await get2(path, {});
  return data;
};

//FIXME: 정기구독여부 확인
export const getBilling = async (params) => {
  let path = `/payments/billing`;
  const { data } = await get2(path, params);
  return data;
};

//TODO: 정기구독 빌링키신청
export const billingReg = async (params) => {
  let path = `/payments/billing/register`;
  const { data } = await post(path, params);
  return data;
};

//TODO: 정기구독신청
export const subscrReg = async (params) => {
  let path = `/payments/subscriptions/register`;
  const data = await post(path, params);
  return data;
};

//TODO: 정기구독해지
export const subscrDelete = async (params) => {
  let path = `/payments/billing`;
  const { data } = await del(path, params);
  return data;
};

//FIXME: 요금제 목록조회
export const getPlans = async (params) => {
  let path = `/payments/plans`;
  const { data } = await get2(path, params);
  return data;
};

//FIXME: 주문생성
export const createOrder = async (params) => {
  let path = `/payments/orders`;
  const { data } = await post2(path, params);
  return data;
};

//FIXME: 주문승인처리
export const orderConfirm = async (params) => {
  let path = `/payments/orders/${params.orderId}/confirm`;
  const { data } = await post2(path, params);
  return data;
};

//FIXME: 구독내역 전체 삭제
export const subscrDeleteAll = async (params) => {
  let path = `/payments/subscriptions/terminate`;
  const { data } = await post(path, params);
  return data;
};

/**
 * 내 구독 목록 조회 (정식 엔드포인트: GET /subscriptions)
 * @param {Object} params - { status?: 'ACTIVE'|'PENDING'|..., subscriptionTypeId?: number }
 * @returns {Array} SubscriptionReadDetail 배열
 */
export const getMySubscriptions = async (params) => {
  let path = `/subscriptions`;
  const { data } = await get2(path, params);
  return data;
};

/**
 * 구독 해지 신청 (정식 엔드포인트: POST /subscriptions/{subscriptionId}/cancel)
 * - body: { cancelReason } — 해지 사유 전달
 */
export const cancelSubscription = async (subscriptionId, cancelReason = '') => {
  let path = `/subscriptions/${subscriptionId}/cancel`;
  const data = await post(path, { cancelReason });
  return data;
};

/**
 * 구독 해지 신청 취소(재개) (정식 엔드포인트: POST /subscriptions/{subscriptionId}/resume)
 * - 해지 신청(cancelRequestedAt)을 되돌려 자동 갱신 유지
 */
export const resumeSubscription = async (subscriptionId) => {
  let path = `/subscriptions/${subscriptionId}/resume`;
  const data = await post(path, {});
  return data;
};

//TODO: 이용중인서비스
export const paymentOwn = async (params) => {
  let path = `/payments/own/product?${params}`;
  const { data } = await get3(path);
  return data;
};

//TODO: 이용중인서비스
export const paymentOwnDetail = async (orderId, params) => {
  let path = `/payments/own/product/${orderId}`;
  const { data } = await get(path, params);
  return data;
};

//TODO: 포인트내역
export const historyPointDetail = async (orderId, params) => {
  let path = `/payments/own/point/history/${orderId}`;
  const { data } = await get(path, params);
  return data;
};

//TODO: 결제취소
export const paymentCancel = async (orderId, params) => {
  let path = `/payments/orders/${orderId}/cancel`;
  const { data } = await post2(path, params);
  return data;
};

//TODO: 해지사유
export const subscrCancelReason = async (params) => {
  let path = `/payments/subscriptions/cancel/reason`;
  const { data } = await get(path, params);
  return data;
};

//TODO: 해지
export const subscrCancel = async (params) => {
  let path = `/payments/subscriptions/cancel`;
  const data = await post(path, params);
  return data;
};

//TODO: 보유포인트 조회
export const ownPoint = async (params) => {
  let path = `/payments/own/point`;
  const { data } = await get(path, params);
  return data;
};

//TODO: 포인트내역
export const historyPoint = async (params) => {
  let path = `/payments/own/point/history`;
  const { data } = await get(path, params);
  return data;
};

export const getPointHistoryAPI = async (params) => {
  let path = `/payments/own/point/history`;
  const response = await get(path, params);
  return response?.data;
};

//TODO: 분석권 사용 내역 조회
export const historyAnalysisTicket = async (params) => {
  let path = `/payments/own/analysis-ticket/history`;
  const { data } = await get2(path, params);
  return data;
};

//TODO: 분석권 상세 사용 내역 조회
export const historyAnalysisLog = async (analysisTicketId, params) => {
  let path = `/payments/own/analysis-log/history/${analysisTicketId}`;
  const { data } = await get(path, params);
  return data;
};

// 구매 후 다음 이동 단계 조회
export const getNextStepAPI = async (analysisTypeId) => {
  let path = `/payments/own/next-step`;
  const { data } = await get(path, { analysisTypeId });
  return data;
};
